import * as A11yDialog from 'a11y-dialog';
import { nodeListToArray } from '../helpers/nodeListToArray';
import * as YouTubeIframeLoader from 'youtube-iframe';
import { Player } from "@vimeo/player"; 

export class Modal {
	modal: any;
	modalElement: HTMLElement;
	video?: any;

	constructor(modalElement: HTMLElement, container?: HTMLElement) {
		let args = container != null ? [modalElement, container] : [modalElement];
		this.modal = new A11yDialog(...args);
		this.modalElement = modalElement;
		this.modal.on('show', () => {
			document.body.style.overflow = 'hidden';
			this.initVideo();
		});
		this.modal.on('hide', () => {
            document.body.style.overflow = '';
            let video = this.modalElement.querySelector('[data-video-type]');
            if (video) {
                this.pauseVideo();
            }
		})
	}

	initVideo() {
		let video = this.modalElement.querySelector('[data-video-type]');
		if (video) {
			let videoType = video.getAttribute('data-video-type');
			if (videoType == 'vimeo') {
				this.vimeoInit();
			}
			else if (videoType == 'youtube') {
				this.youtubeInit();
			}
			else {
				this.nativeVideoInit();
			}
		}
	}

	vimeoInit() {
		let vimeoIframe = this.modalElement.querySelector('iframe');
		if (!vimeoIframe.src) {
			vimeoIframe.src = vimeoIframe.getAttribute('data-src');
			let vimeoPlayer = new Player(vimeoIframe, {});
			this.video = vimeoPlayer;
		}
	}

	youtubeInit() {
  //      let youtubeIframe = this.modalElement.querySelector('iframe');
  //      this.loadAPI();
		//if (!youtubeIframe.src) {
  //          this.onYouTubeIframeAPIReady();
		//} 
    }

    loadAPI() {
        var youTubeVideoTag = document.createElement('script');
        youTubeVideoTag.type = 'text/javascript';
        youTubeVideoTag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(youTubeVideoTag);
    }

    //onYouTubeIframeAPIReady = function () {
    //    let youtubeIframe = this.modalElement.querySelector('iframe');
    //    let uniqueID = this.modalElement.id;
    //    if (window['YT'] == null) {
    //        YouTubeIframeLoader.load(YT => {
    //            let playerID = `youtube-player-${uniqueID}`;
    //            youtubeIframe.id = playerID;
    //            youtubeIframe.src = youtubeIframe.getAttribute('data-src');
    //            let youtubePlayer = new YT.Player(playerID, {});
    //            this.video = youtubePlayer;
    //        });
    //    } else {
    //        let playerID = `youtube-player-${uniqueID}`;
    //        youtubeIframe.id = playerID;
    //        youtubeIframe.src = youtubeIframe.getAttribute('data-src');
    //        let youtubePlayer = new window['YT'].Player(playerID, {});
    //        this.video = youtubePlayer;
    //    }
    //};

	nativeVideoInit() {
		let videoElement = this.modalElement.querySelector('video');
		if (videoElement) {
			let videoSource = videoElement.querySelector('source');
			if (!videoSource.src) {
				videoSource.src = videoSource.getAttribute('data-src');
				videoElement.load();
			}
			this.video = videoElement;
		}
	}

	pauseVideo() {
        let videoContainer = this.modalElement.querySelector('[data-video-type]');
        if (videoContainer.getAttribute('data-video-type') == 'vimeo') {
            this.video.pause();
        }
        else if (videoContainer.getAttribute('data-video-type') == 'youtube') {
            var youtubeIframe = this.modalElement.querySelector('iframe');
            youtubeIframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');

            //if (this.video.pauseVideo == undefined) {
            //    var youtubeIframe = this.modalElement.querySelector('iframe');
            //    youtubeIframe.src = '';
            //    youtubeIframe.src = youtubeIframe.getAttribute('data-src');
            //} else {
            //    this.video.pauseVideo();
            //}

        }
        else {
            if (!this.video.paused) {
                this.video.pause();
            }
        }
	}
}